const muiMenuItemTheme = (theme) => {
  theme.overrides.MuiMenuItem = {
    root: {
      height: 'unset',
      minHeight: '35px',
      whiteSpace: 'unset',
    },
  };
};

export default muiMenuItemTheme;
